import { UPDATE_LICENSE } from "../types/licenseTypes";

export const updateLicense = value => ({
    type: UPDATE_LICENSE,
    license: value
});